module.exports = __webpack_public_path__ + "static/mixta-bold-31680cbaeedf933dac462ac7649602ba.otf";